"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmation = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/List/List");
require("../../../TdWebtoolkitControls/controls/Menu/MethodManager");
const synerisMethods_1 = require("../../../TdWebtoolkitControls/controls/Menu/synerisMethods");
require("../../../TdWebtoolkitControls/controls/Preview/Preview");
require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const ConfirmationModel_1 = require("../../../TdWebtoolkitControls/model/ConfirmationModel");
const $ = require("jquery");
const m = require("../SynView");
const r_conf = require("../confirmation/confirmation.config");
let r_confTemplate = require("./lists/confirmationObj.tmpl.htm");
let r_confTemplateGlue = require("./lists/confirmation_glue");
let r_confHistoryTemplate = require("./lists/confirmationObjHistory.tmpl.htm");
let r_confHistoryTemplateGlue = require("./lists/confirmation_glue_history");
let r_css = require("./confirmation.tmpl.less");
class confirmation extends m.SynView {
    //#endregion MEMBER VARIABLES
    //#region CONTRUCTORS
    constructor() {
        super();
        this.m_hasMenu = false;
    }
    //#endregion CONTRUCTORS
    //#region MEMBER METHODS
    //#region Inherited from SynView
    // Initialization of member variables
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        let pageSizeString = Utilities_1.synUtil.Configs.getValue("bestg.ui.pagesize", "10");
        let pageSize = parseInt(pageSizeString, 10);
        if (isNaN(pageSize) || pageSize < 0)
            pageSize = 10;
        this.m_listOptions = ({
            pageSize,
            messages: {
                display: Utilities_1.synUtil.Strings.getValue("listdisplay"),
                empty: Utilities_1.synUtil.Strings.getValue("listemtpy"),
                page: Utilities_1.synUtil.Strings.getValue("listpage"),
                of: Utilities_1.synUtil.Strings.getValue("listof"),
                itemsPerPage: Utilities_1.synUtil.Strings.getValue("listitemsperpage"),
                first: Utilities_1.synUtil.Strings.getValue("listfirstpage"),
                previous: Utilities_1.synUtil.Strings.getValue("listpreviouspage"),
                next: Utilities_1.synUtil.Strings.getValue("listnextpage"),
                last: Utilities_1.synUtil.Strings.getValue("listlastpage"),
                refresh: Utilities_1.synUtil.Strings.getValue("refresh")
            }
        });
        this.m_viewConfig = $.extend({
            defaultFields: [
                "id",
                "icon",
                "name",
                "cgdoctype.name",
                "cgdocument.ceobjdate",
                "cgdocument.doclabel",
                "cgdocument.doccomment",
                "cgdocument.lastchangedate",
                "cebest.bestuserid",
                "cebest.syndocid",
                "cebest.synversion"
            ],
            documentFields: [],
            documentSort: [],
            historySort: []
        }, r_conf.confirmationConfig),
            this.icon = "fa-check-square-o";
        this.m_classValueKeys = ["bestg.responsibleemail"];
    }
    renderContents() {
        let that = this;
        that.m_$listPane = that.m_$container.find("#listPane");
        that.restoreSplitterState(that.m_$listPane);
        that.m_$preview = that.m_$container.find("#Preview");
        that.m_$confirmationsPane = that.m_$container.find("div.confirmationPane");
        that.m_$confirmationsListView = that.m_$container.find("div.confirmationsListView");
        that.m_$confirmationsPager = that.m_$container.find(".confirmationsPager");
        that.m_$confirmationsHistoryPane = that.m_$container.find("div.historyPane");
        that.m_$confirmationsHistoryListView = that.m_$container.find(".confirmationsHistoryListView");
        that.m_$confirmationsHistoryPager = that.m_$container.find(".confirmationsHistoryPager");
        for (let key in that.m_viewConfig.fieldMapping) {
            let field = that.m_viewConfig.fieldMapping[key];
            if (field) {
                if ($.inArray(field, that.m_viewConfig.documentFields) < 0)
                    that.m_viewConfig.documentFields.push(field);
                $.merge(that.m_viewConfig.documentFields, that.m_viewConfig.defaultFields);
            }
        }
        this.m_$confirmationsPane.children(".headline").text(Utilities_1.synUtil.Strings.getValue("confirmationactiveheadline"));
        this.m_$confirmationsHistoryPane.children(".headline").text(Utilities_1.synUtil.Strings.getValue("confirmationhistoryheadline"));
        that.m_$preview.synPreview({});
        that.m_$confirmationsHistoryPager.hide();
        that.m_$confirmationsPager.hide();
        this.renderConfirmations();
        this.renderHistory();
    }
    togglePane($pane, collapse) {
        super.togglePane($pane, collapse);
        if ($pane.is(this.m_$confirmationsHistoryPane) && this.m_historyDS && !collapse)
            this.m_historyDS.read();
    }
    forceRefresh(modificationInfo) {
        this.m_confirmationDS.read();
        if (!this.m_$confirmationsHistoryPane.data("pane").collapsed)
            this.m_historyDS.read();
    }
    //#region Helpers
    renderConfirmations() {
        this.renderCore(false);
    }
    renderHistory() {
        this.renderCore(true);
    }
    renderCore(history) {
        let that = this;
        let $pager = history ? that.m_$confirmationsHistoryPager : that.m_$confirmationsPager;
        let $listView = history ? that.m_$confirmationsHistoryListView : that.m_$confirmationsListView;
        let sort = history ? that.m_viewConfig.historySort : that.m_viewConfig.documentSort;
        let confTemplate = history ? r_confHistoryTemplate : r_confTemplate;
        let glue = history ? r_confHistoryTemplateGlue.confirmation_glue_history : r_confTemplateGlue.confirmation_glue;
        let dataSource = new kendo.data.DataSource({
            transport: {
                read(options) {
                    Utilities_1.synUtil.getAJAXData({
                        method: "POST",
                        requestData: {
                            fieldNames: JSON.stringify(that.m_viewConfig.documentFields),
                            history
                        },
                        url: Utilities_1.synUtil.getWSUrl("WorkflowConfirmationInstances"),
                        done(dataJSON) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let confirmationModel = yield ConfirmationModel_1.ConfirmationModel.fromJSON(dataJSON);
                                options.success(confirmationModel.data);
                            });
                        }
                    });
                }
            },
            change(e) {
                let data = this.data();
                let pageSize = this.pageSize();
                if (pageSize != undefined && data.length > pageSize)
                    $pager.show();
                else
                    $pager.hide();
            },
            pageSize: that.m_listOptions.pageSize === 0 ? undefined : that.m_listOptions.pageSize,
            sort
        });
        if (history)
            that.m_historyDS = dataSource;
        else
            that.m_confirmationDS = dataSource;
        let autoBind = true;
        if (history)
            autoBind = !this.getSplitterConfig(this.m_$listPane).m_paneConfigs[1].m_collapsed;
        $listView.kendoListView({
            autoBind,
            dataSource,
            template(item) {
                let template = kendo.template(confTemplate);
                let itemRow = "";
                item["synUtil"] = Utilities_1.synUtil;
                item["synerisMethods"] = synerisMethods_1.synerisMethods;
                item["getImageUrl"] = (inst) => {
                    let imgUrl = inst.icon.value ? inst.icon.valueAsString : "transparent";
                    return Utilities_1.synUtil.getWSUrl("Icon") + imgUrl + "/16";
                };
                item["mapField"] = (inst, fieldName) => {
                    let mappedFieldName = that.m_viewConfig.fieldMapping[fieldName];
                    if (mappedFieldName && inst[mappedFieldName])
                        return inst[mappedFieldName].value.toString();
                    return undefined;
                };
                try {
                    itemRow = template(item);
                }
                catch (e) {
                    $.errorDialog({
                        ErrorDisplayMessage: "Error rendering "
                            + (history ? "history" : "active")
                            + " confirmation items: " + e.message
                    });
                }
                return itemRow;
            },
            dataBound() {
                glue.init({
                    dataSource,
                    reloadData() { that.reloadData(); },
                    showPreview(id) { that.showPreview(id); }
                });
                if (history) {
                    that.m_$confirmationsHistoryListView.find("a").each(function (index) {
                        that.bindOnClick($(this));
                    });
                }
                else {
                    that.m_$confirmationsListView.find("a").each(function (index) {
                        that.bindOnClick($(this));
                    });
                }
            }
        });
        $listView.off("td.confInstance", "click").on("td.confInstance", "click", function () {
            let docId = $(this).closest('tr').data("id").split("_")[1];
            that.m_$preview.synPreview("setInstanceAsync", docId);
        });
        $pager.kendoPager({
            dataSource,
            messages: that.m_listOptions.messages
        });
    }
    bindOnClick($target) {
        let method = $target.data("method");
        let id = $target.data("methodid");
        let newWindow = $target.data("methodnewwindow");
        let options = {};
        if (newWindow)
            options["newWindow"] = newWindow;
        if (method && id) {
            if (method === "cefunc.26" && $target.hasClass("noContent"))
                return;
            method = method.split(".");
            $target.on("click", function () {
                synerisMethods_1.synerisMethods[method[0]][method[1]].impl([id], undefined, undefined, undefined, options);
            });
        }
    }
    showPreview(id) {
        let that = this;
        let $id = id.replace(/\|/g, "_");
        that.m_$confirmationsListView.find(".btn.preview").removeClass("btn-hightlight");
        that.m_$confirmationsListView.find(".for-id-" + $id).find(".btn.preview").addClass("btn-hightlight");
        that.m_$preview.synPreview("setInstanceAsync", id);
    }
    reloadData() {
        let cfg = this.getSplitterConfig(this.m_$listPane);
        if (!cfg.m_paneConfigs[1].m_collapsed && this.m_historyDS)
            this.m_historyDS.read();
        if (this.m_confirmationDS)
            this.m_confirmationDS.read();
    }
}
exports.confirmation = confirmation;
